import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { ArrowLeft, Search as SearchIcon } from "lucide-react";
import Header from "./Header";
import Footer from "./Footer";

export default function NotFoundView({ message }) {
  return (
    <div className="App">
      <Helmet prioritizeSeoTags>
        <title>{`${message} · Foton Enduroskola`}</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="prerender-status-code" content="404" />
      </Helmet>
      <Header />
      <div className="max-w-3xl mx-auto px-6 py-24 text-center" data-testid="not-found-view">
        <h1 className="font-display font-black uppercase text-white text-4xl sm:text-5xl mb-4" data-testid="not-found-title">
          {message}
        </h1>
        <p className="text-white/60 mb-8">Sidan du letar efter finns inte eller har flyttats.</p>
        <div className="flex flex-wrap justify-center gap-4">
          <Link to="/" className="btn-secondary text-sm py-2 inline-flex items-center gap-2" data-testid="not-found-home-link">
            <ArrowLeft className="w-4 h-4" /> Till startsidan
          </Link>
          <Link to="/search" className="btn-secondary text-sm py-2 inline-flex items-center gap-2" data-testid="not-found-search-link">
            <SearchIcon className="w-4 h-4" /> Sök bilder
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
